<template>
  <div>
    <form enctype="multipart/form-data">
      <legal-consent-file-input
        class="border-dashed border-2 rounded mb-4 border-gray"
        name="file"
        :is-saving="isSaving"
        :allowed-file-types="allowedFileTypes"
        @change="fileSave"
        @error="onFileInputError"
      />
    </form>
    <collection :designs="customerUploads" @item-clicked="selectUpload" />
  </div>
</template>

<script>
import CollectionGrid from '../../components/CollectionGrid.vue';
import LegalConsentFileInput from '../../components/input/LegalConsentFileInput.vue';
import { ACTION_AWAIT_REQUEST } from '../../store/action-types';
import { mapState } from 'pinia/dist/pinia';
import { useCustomerUploadsStore } from '@/store-pinia/customerUploads';

export default {
  name: 'UploadList',
  components: {
    LegalConsentFileInput,
    collection: CollectionGrid
  },
  data: () => ({
    allowedFileTypes: ['image/png', 'image/jpeg', 'image/gif'],
    isSaving: false,
    legalConsentGiven: false
  }),
  computed: {
    ...mapState(useCustomerUploadsStore, ['customerUploads'])
  },
  methods: {
    fileSave(fieldName, files) {
      if (0 === files.length) return;

      const formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        formData.append(fieldName + '[]', files[i], files[i].name);
      }

      formData.append('legalConsent', true);

      this.isSaving = true;
      this.$store.dispatch(ACTION_AWAIT_REQUEST, async () => {
        await useCustomerUploadsStore()
          .uploadCustomerDesigns(formData)
          .then(uploadErrors => {
            uploadErrors.forEach(error => this.showError(error));
          })
          .finally(() => {
            this.isSaving = false;

            // SS-3731 Automatically place uploaded image on the print side
            if (this.customerUploads.length > 0) {
              this.selectUpload(
                this.customerUploads[this.customerUploads.length - 1]
              );
            }
          });
      });
    },
    showError(error) {
      this.$toasted
        .show(this.getErrorTranslation(error.error) + ` ${error.file}`, {
          action: {
            class: 'text-white', // This is being overriden :(
            text: this.getErrorTranslation('close'),
            onClick: (e, toastedObject) => toastedObject.goAway(0)
          },
          type: 'error'
        })
        .goAway(5000);
    },
    getErrorTranslation(errorKey) {
      return this.$t(`customization.error.${errorKey}`);
    },
    onFileInputError(error, file) {
      this.showError({
        error,
        file: file.name
      });
    },
    selectUpload(upload) {
      this.$emit('select-upload', upload);
    }
  }
};
</script>
